import { Dispatch, SetStateAction, useCallback } from 'react';

const useHandleBlur = ({ setIsFocused }: { setIsFocused: Dispatch<SetStateAction<boolean>> }) => {
  return useCallback(() => {
    setIsFocused(false);
  }, [setIsFocused]);
};

export default useHandleBlur;
